import { usersCollection } from "@/firebase";
import { usersStatsCollection } from "@/firebase";
import { fcmTokensCollection } from "@/firebase";
import { messaging } from "@/firebase";
import store from "@/store";

const state = {
  user: null, // users profile data from firebase auth
  userProfile: {}, // users additional profile data
  moderatorOnline: [],
  isAuthenticated: false,
  fcmToken: {},
};

const getters = {
  isAuthenticated(state) {
    return state.user !== null && state.user !== undefined;
  },
};

const actions = {
  /*
   * SET ONLINE / OFFLINE
   */
  // eslint-disable-next-line
  setOnline({ commit }, payload) {
    return new Promise((resolve, reject) => {
      usersCollection
        .doc(store.state.storeAuth.user.uid)
        .set({ online: payload }, { merge: true })
        .then(() => {
          resolve();
        })
        .catch(function (error) {
          console.error(error);
          reject();
        });
    });
  },
  // eslint-disable-next-line
  updateConfirmations({ commit }, payload) {
    return new Promise((resolve, reject) => {
      usersCollection
        .doc(store.state.storeAuth.user.uid)
        .set({
          allowCookies: payload.allowCookies,
          allowRules: payload.allowRules,
          allowPrivacy: payload.allowPrivacy,
        }, { merge: true })
        .then(() => {
          resolve(commit("updateConfirmations", payload));
        })
        .catch(function (error) {
          console.error(error);
          reject();
        });
    });
  },
  // dodamo statistiko, če je še ni
  // eslint-disable-next-line
  setUserStats({ commit }, payload) {
    return new Promise((resolve, reject) => {
      usersStatsCollection
        .where("uid", "==", payload.uid)
        .where("client", "==", payload.client)
        .limit(1)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.empty) {
            usersStatsCollection
              .add(payload)
              .then(() => {
                resolve({ orders: 0, ordersSum: 0 });
              })
              .catch((error) => {
                console.log(error);
                reject();
              });
          } else {
            querySnapshot.forEach((doc) => {
              usersStatsCollection
                .doc(doc.id)
                .set(
                  {
                    orders: doc.data().orders + payload.orders,
                    ordersSum: doc.data().ordersSum + payload.ordersSum,
                    timestamp: new Date(Date.now())
                  },
                  { merge: true }
                )
                .then(() => {
                  resolve({ orders: doc.data().orders + payload.orders, ordersSum: doc.data().ordersSum + payload.ordersSum });
                })
                .catch((err) => {
                  console.log(err);
                  reject();
                });
            });
          }
        })
        .catch(function (error) {
          reject(console.log("Error getting documents: ", error));
        });
    });
  },
  fetchUserProfile({ commit, state }) {
    return new Promise((resolve, reject) => {
      const defaultUserData = {
        allowFCMOrderNotification: true,
        isCompany: false,
        vatNumber: "",
        fullName:
          state.user.displayName !== null
            ? state.user.displayName
            : "",
        online: true,
        address1: "",
        address2: "",
        country: "",
        phone: state.user.phoneNumber !== null ? state.user.phoneNumber : "",
        email: state.user.email,
        isModerator: false,
        isSuperStoreAdmin: false,
        isSuperAdmin: false,
        isAdmin: false,
        client: "",
        isAdminShowPackages: [],
        isAdminSendNewPackagesMessage: true,
        ordersNum: 0, // koliko naročil
        ordersSum: 0, // za koliko denarja
        allowCookies: false,
        allowRules: false,
        allowPrivacy: false,
      };
      // če uporabnik, še ne obstaja, dodamo dodatna polja v users
      // sicer vrednosti samo preberemo
      let vm = this;
      usersCollection
        .doc(state.user.uid)
        .get()
        .then(function (doc) {
          if (!doc.exists) {
            // create user obj
            usersCollection
              .doc(state.user.uid)
              .set(defaultUserData)
              .then(() => {
                commit("setUserProfile", defaultUserData);
                resolve();
              })
              .catch((error) => {
                reject();
                return error;
              });
          } else {
            usersCollection
              .doc(state.user.uid)
              .get()
              .then((res) => {
                vm.dispatch("setOnline", true).then(() => {
                  commit("setUserProfile", { ...res.data(), online: true });
                  resolve();
                });
              })
              .catch((err) => {
                console.log(err);
                reject();
              });
          }
        })
        .catch(function (error) {
          return error;
        });
    });
  },
  /***************/
  /* USER RIGHTS */
  /***************/
  // eslint-disable-next-line
  async setUserRights({ commit }, payload) {
    let result = false;
    await usersCollection
      .where("email", "==", payload.email)
      .where("client", "in", ["", payload.client])
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          usersCollection.doc(doc.id).set(payload, { merge: true });
          result = true;
        });
      });
    return result;
  },
  // eslint-disable-next-line
  getModeratorOnline({ commit }, payload) {
    usersCollection
      .where("client", "==", payload.client)
      .where("isModerator", "==", true)
      .orderBy("online", "desc")
      .onSnapshot((snapshot) => {
        let tempData = {};
        snapshot.docChanges().forEach(
          (change) => {
            if (change.doc.id != payload.uid) {
              tempData = Object.assign(
                {},
                {
                  id: change.doc.id,
                  fullName: change.doc.data().fullName,
                  online: change.doc.data().online,
                  email: change.doc.data().email,
                }
              );

              if (change.type == "added") {
                commit("addModeratorOnline", tempData);
              } else if (change.type == "modified") {
                commit("editModeratorOnline", tempData);
              } else if (change.type == "removed") {
                commit("deleteModeratorOnline", tempData);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
      });
  },
  /*********************/
  /* USERSETTINGS.VUE */
  /*********************/
  async saveUserSettings({ commit }, payload) {
    let result = false;
    await usersCollection
      .doc(this.state.storeAuth.user.uid)
      .set(payload, { merge: true })
      .then(() => {
        commit("saveUserSettings", payload);
        result = true;
      });
    return result;
  },
  async setFCMAllow({ commit }, payload) {
    let result = false;
    this.dispatch("saveUserSettings", { allowFCMOrderNotification: payload });

    if (!messaging) return result;

    if (payload) {
      await messaging
        .requestPermission()
        .then(() => {
          //console.log("Notification permission granted.");
          // Get Token
          messaging.getToken().then((token) => {
            // preverimo, ali točno tak token s tem uporabnikom in klientom že obstaja
            fcmTokensCollection
              .where("token", "==", token)
              .where("uid", "==", this.state.storeAuth.user.uid)
              .where(
                "client",
                "==",
                store.state.storeClient.client.basicSettings.name
              )
              .limit(1)
              .get()
              .then((querySnapshot) => {
                // če token ne obstaja dodamo novega
                if (querySnapshot.empty) {
                  fcmTokensCollection
                    .add({
                      token: token,
                      uid: this.state.storeAuth.user.uid,
                      client: store.state.storeClient.client.basicSettings.name,
                    })
                    // eslint-disable-next-line
                    .then((docRef) => {
                      commit(
                        "setFcmToken",
                        Object.assign(
                          {},
                          {
                            token: token,
                            uid: this.state.storeAuth.user.uid,
                            client:
                              store.state.storeClient.client.basicSettings.name,
                          },
                          { id: docRef.id }
                        )
                      );
                      result = true;
                    });
                } else {
                  // če obstaja pa naredimo samo lokalni commit
                  querySnapshot.forEach((doc) => {
                    commit(
                      "setFcmToken",
                      Object.assign(
                        {},
                        {
                          id: doc.id,
                          token: token,
                          uid: this.state.storeAuth.user.uid,
                          client:
                            store.state.storeClient.client.basicSettings.name,
                        }
                      )
                    );
                    result = true;
                  });
                }
              });
          });
        })
        .catch((err) => {
          console.log("Unable to get permission to notify.", err);
        });
    }
    return result;
  },
};

const mutations = {
  setIsAuthenticated(state, payload) {
    state.isAuthenticated = payload;
  },
  setUser(state, payload) {
    state.user = payload;
  },
  updateConfirmations(state, payload) {
    Object.assign(
      state.user,
      payload
    );
  },

  // MODERATOR ONLINE
  clearModeratorOnline(state) {
    state.moderatorOnline = [];
  },
  addModeratorOnline(state, payload) {
    state.moderatorOnline.push(payload);
    state.moderatorOnline.sort(function (x, y) {
      return x === y ? 0 : x ? 1 : -1;
    });
    //console.log(state.moderatorOnline);
  },
  editModeratorOnline(state, payload) {
    const index = state.moderatorOnline.findIndex(
      (item) => item.id == payload.id
    );
    state.moderatorOnline.splice(index, 1, payload);
    state.moderatorOnline.sort(function (x, y) {
      return x === y ? 0 : x ? 1 : -1;
    });
  },
  deleteModeratorOnline(state, payload) {
    const index = state.moderatorOnline.findIndex(
      (item) => item.id == payload.id
    );
    state.moderatorOnline.splice(index, 1);
    state.moderatorOnline.sort(function (x, y) {
      return x === y ? 0 : x ? -1 : 1;
    });
  },

  setFcmToken(state, payload) {
    state.fcmToken = payload;
  },
  setUserProfile(state, val) {
    state.userProfile = val;
  },
  // USERSETTINGS
  saveUserSettings(state, payload) {
    Object.assign(state.userProfile, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
